// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#send-comment-report, #cancel-comment-report{
    padding: 10px;
    color:white;
    border: none;
    border-radius: 1em;
    margin: 0.25em;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}

#send-comment-report{
    background-color: rgba(237, 31, 28, 0.738);
}

#send-comment-report:hover{
    background-color: #913f3f;
}

#cancel-comment-report{
    background-color: rgba(139, 183, 240, 0.813);
}

#cancel-comment-report:hover{
    background-color: #007bff;
}`, "",{"version":3,"sources":["webpack://./src/css/reportComment.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["#send-comment-report, #cancel-comment-report{\n    padding: 10px;\n    color:white;\n    border: none;\n    border-radius: 1em;\n    margin: 0.25em;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n#send-comment-report{\n    background-color: rgba(237, 31, 28, 0.738);\n}\n\n#send-comment-report:hover{\n    background-color: #913f3f;\n}\n\n#cancel-comment-report{\n    background-color: rgba(139, 183, 240, 0.813);\n}\n\n#cancel-comment-report:hover{\n    background-color: #007bff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
